<template>
  <el-select v-model="value" v-on="$listeners" v-bind="$attrs" clearable filterable style="width: 120px"
             :multiple="multiple"
             v-loading="loading"
             :collapse-tags="!unCollapseTags"
             placeholder="乙方名称">
    <el-option v-for="(item, index) in companyOption"
               :key="index"
               :label="item.label"
               :value="item.value"
               :disabled="!history&&item.status!=='Y'"
    />
  </el-select>
</template>

<script>
import {getCompanyOptions} from "@/api/adOrder";
import {getCompanyOtOptions} from "@/api/company";

export default {
  name: "companySelect",
  props: {
    companyId: {
      type: [Number, String, Array],
      default() {
        return null;
      }
    },
    projectType: {
      type: [Number, String],
      default() {
        return '';
      }
    },
    unCollapseTags: Boolean,
    multiple: Boolean,
    history: Boolean,
  },
  computed: {
    value: {
      get() {
        return this.companyId
      },
      set(val) {
        this.$emit('update:companyId', val)
        let row = this.companyOption.find(value => value.value === val)
        this.$emit('selected', row)
      }
    }
  },
  data() {
    return {
      companyOption: [],
      loading: false,
    }
  },
  mounted() {
    this.getCompanyOption()
  },
  methods: {
    getCompanyOption: async function () {
      this.loading = true;
      let options, default_company_id
      if (this.projectType) {
        const {model} = await getCompanyOtOptions({project_type: this.projectType})
        options = model.options || [];
        default_company_id = model.default_company_id
      } else {
        const {data} = await getCompanyOptions()
        options = data.options || [];
      }

      this.companyOption = options || [];
      this.loading = false;
      this.setDefaultCompanyId(default_company_id)
    },
    /**
     * 设置默认乙方id
     * @param value
     */
    setDefaultCompanyId(value) {
      if (this.companyId || !value) {
        return;
      }
      const tmp = this.companyOption.find(option => {
        return parseInt(option.value) === parseInt(value)
      })
      if (tmp) {
        this.value = tmp.value
      }
    }
  }
}
</script>

<style scoped>

</style>
